<template>
  <div class="text-dark">
    <h3 class="title text-capitalize">Les prochains lives</h3>
<!--    <div class="loader" v-if="loading"></div>-->
    <carousel v-if="!loading && conferences.length" class="conference-slider" :navigation-enabled="true"
              :space-padding="0" :per-page-custom="[[480,2],[768,3],[1200,4]]"
              :pagination-enabled="false" :navigation-click-target-size="0"
              :scroll-per-page="false">
      <slide class="conference-slide" v-for="(conference, j) in conferences" v-if="show(conference)" :key="j">
        <live :conference="conference"></live>
      </slide>
    </carousel>
    <p class="text-center" v-if="!loading && !conferences.length">
      Aucun live n'est disponible pour le moment !
    </p>
  </div>
</template>

<script>
import NextConferenceView from "./NextConferenceView";
import {mapGetters} from 'vuex';
import moment from 'moment'

export default {
  name: "NextConferences",
  components: {
    'live': NextConferenceView
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      'conferences': 'conference/next_conferences',
      'loading': 'conference/next_loading',
      'now': 'now'
    })
  },
  methods: {
    show(conference) {
      if (conference.type === 'exam') {
        return moment(conference.date).add(conference.duration, 'minute').diff(this.now, 's') > 0
      }
      return true
    }
  },
  mounted() {
    this.$store.dispatch('conference/fetchNextConferences')
  },
}
</script>
<style>
.conference-slide {
  min-width: 0;
  padding-bottom: 5px;
}
</style>
